import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

const MATE = `${shop_url}/shop/app/company/employeeInfo`

/* 获取员工 */
export const getMatesByCompanyId = (data) => {
  return fetch({
    url: MATE + '/' + data.id + '/' + data.page + '/' + data.size
  })
}
/* 搜索员工 */
export const serMatesByCompanyId = (data) => {
  return fetch({
    url: MATE + '/' + data.id + '/' + data.page + '/' + data.size + '?keyword=' + data.keyword
  })
}
/* 请离员工 */
export const delMateById = (companyId, mId) => {
  return fetch({
    url: MATE + '/' + companyId + '/' + mId,
    method: 'delete'
  })
}
/* 请离员工并扣款 */
export const delMateByIds = (data) => {
  return fetch({
    url: `${shop_url}/shop/pms/company/account/refund`,
    method: 'post',
    data
  })
}
/* 编辑员工 */
export const editMateById = (data) => {
  return fetch({
    url: MATE,
    method: 'put',
    data
  })
}
/* 添加员工 */
export const addMateById = (data) => {
  return fetch({
    url: MATE,
    method: 'post',
    data
  })
}
/* 获取公司员工姓名 */
export const getMateNameByPhone = (data) => {
  const { phone, companyId } = data
  return fetch({
    url: `${shop_url}/shop/app/company/employee?phone=${phone}&companyId=${companyId}`,
    method: 'get'
  })
}
/* 按部门搜索 */
export const serMatesByDepartment = (data) => {
  return fetch({
    url: MATE + '/' + data.id + '/' + data.page + '/' + data.size + '?deptId=' + data.deptId
  })
}
